import React, { Component } from "react";
import {
  forgotPasswordConfirm,
  forgotPassword,
} from "../../redux/actions/authActions";
import { connect } from "react-redux";
import { Input, Button, Form } from "antd";
import { Alert } from "../../components";
import { Cookies } from "../../helpers";

import { LocalStorage } from "../../helpers";

export class OTPVertification extends Component {
  state = {
    birthDate: "",

    OTP: {
      1: null,
      2: null,
      3: null,
      4: null,
      5: null,
      6: null,
    },
  };
  onInputFocus = (e) => {
    e.target.select();
  };

  maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };
  handleResend = () => {
    this.props.form.resetFields();
    let data = {
      memberId: this.props.destination.memberId,
      phoneNumber: this.props.destination.phoneNumber,
      birthDate: this.props.birthDate,
      email: this.props.destination.email,
    };
    if (this.props.destination.phoneNumber) {
      data.birthDate = this.props.birthDate;
    }
    this.props.forgotPassword(data);
  };
  handleOTPChange = (e, id) => {
    const inputElement = document.getElementById(id);
    this.setState(
      (this.state.OTP = {
        ...this.state.OTP,
        [id.split("-")[1]]: e.target.value,
      })
    );
    if (e.target.value != "" && inputElement.nextSibling) {
      inputElement.nextSibling.focus();
    }
    if (e.target.value == "" && inputElement.previousSibling) {
      inputElement.previousSibling.focus();
    }
    if (!inputElement.nextSibling) {
      // console.log(
      //   "Object.values(this.state.OTP)",
      //   Object.values(this.state.OTP)
      //     .join("")
      //     .replaceAll(",", "")
      // );
    }
  };
  handleVerify = (e) => {
    e.preventDefault();
    // console.log("this.props.userData", this.props.userData);
    let data = {
      code: Object.values(this.state.OTP)
        .join("").toString().replace(/\,/g, ""),
      memberId: this.props.userData.memberId,
    };
   
    this.props.forgotPasswordConfirm(data);
  };
  addProviderOrangeHandleVerify = (e) => {
    e.preventDefault();
    const memberId = Cookies.get("memberId") || undefined;

    // console.log("this.props.userData", this.props.userData);
    let data = {
      providerId: "1",
      smsCode: Number(
        Object.values(this.state.OTP)
          .join("")
          .toString()
          .replace(/\,/g, "")
      ),
      phoneNumber: `231077` + this.props.orangePhoneNumber,
    };
    // console.log("data9939933", data);
    this.props.AddMemberProviders(data);

    // "smsCode": 0,
    // "phoneNumber": "string"
    // this.props.forgotPasswordConfirm(data);
  };
  addProviderMTNHandleVerify = (e) => {
    e.preventDefault();
    const memberId = Cookies.get("memberId") || undefined;

    // console.log("this.props.userData", this.props.userData);
    let data = {
      providerId: "2",
      smsCode: Number(
        Object.values(this.state.OTP)
          .join("")
          .toString().replace(/\,/g, "")
      ),
      phoneNumber: `231088` + this.props.MTNPhoneNumber,
    };
    // console.log("data9939933", data);
    this.props.AddMemberProviders(data);

    // "smsCode": 0,
    // "phoneNumber": "string"
    // this.props.forgotPasswordConfirm(data);
  };
  render() {
    const formItemLayout = null;
    const { getFieldDecorator } = this.props.form;
    const { message, success } = this.props;
    // console.log(
    //   "this.props.addMemberProviderErrorMessage-1",
    //   this.props.addMemberProviderErrorMessage
    // );
    // console.log(
    //   "this.props.addMemberProviderErrorMessage-2",
    //   this.props.addMemberProviderStatus
    // );
    // console.log(
    //   "this.props.addMemberProviderErrorMessage-3",
    //   this.props.addMemberProviderSuccessMessage
    // );

    return (
      <div id="OTP-Vertification">
        <div id="OTP-vertification-parent-container">
          <p className="forget-password-headline">OTP Vertification</p>
          {!this.props.FromAddProvider && message && (
            <Alert type="error" icon="!" message={message} />
          )}
          {this.props.FromAddProvider && !this.props.addMemberProviderStatus &&
            this.props.addMemberProviderErrorMessage && (
              <Alert
                type="error"
                message={this.props.addMemberProviderErrorMessage}
              />
            )}
          {this.props.FromAddProvider && this.props.addMemberProviderStatus && (
            <Alert
              type="success"
              message={this.props.addMemberProviderSuccessMessage}
            />
          )}
          {this.props.FromAddProvider && this.props.resendSmsMessage && !this.props.addMemberProviderStatus && (
            <Alert
              type="success"
              message={this.props.resendSmsMessage}
            />
          )}
         

          <Form
            onSubmit={
              this.props.orangePhoneNumber &&
              this.props.orangePhoneNumber.length > 0
                ? this.addProviderOrangeHandleVerify
                : this.props.MTNPhoneNumber &&
                  this.props.MTNPhoneNumber.length > 0
                ? this.addProviderMTNHandleVerify
                : this.handleVerify
            }
          >
            <div>
              <div
                className="forget-password-input-label-container"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  whiteSpace: "nowrap",
                }}
              >
                {/* <Form.Item label="Code" {...formItemLayout}>
              {getFieldDecorator("code", {
                rules: [{ required: true }],
              })(
                <Input className="confirmation-input" type="number" />
              )}
            </Form.Item> */}
                <div className="OTP-fields">
                  <Form.Item {...formItemLayout}>
                    <Input
                      onFocus={(e) => this.onInputFocus(e)}
                      onChange={(e) => this.handleOTPChange(e, "opt-1")}
                      id="opt-1"
                      className="confirmation-input"
                      type="number"
                      maxLength={1}
                      onInput={this.maxLengthCheck}
                    />
                    <Input
                      onFocus={(e) => this.onInputFocus(e)}
                      onChange={(e) => this.handleOTPChange(e, "opt-2")}
                      id="opt-2"
                      className="confirmation-input"
                      type="number"
                      maxLength={1}
                      onInput={this.maxLengthCheck}
                    />
                    <Input
                      onFocus={(e) => this.onInputFocus(e)}
                      onChange={(e) => this.handleOTPChange(e, "opt-3")}
                      id="opt-3"
                      className="confirmation-input"
                      type="number"
                      maxLength={1}
                      onInput={this.maxLengthCheck}
                    />
                    <Input
                      onFocus={(e) => this.onInputFocus(e)}
                      onChange={(e) => this.handleOTPChange(e, "opt-4")}
                      id="opt-4"
                      className="confirmation-input"
                      type="number"
                      maxLength={1}
                      onInput={this.maxLengthCheck}
                    />
                    <Input
                      onFocus={(e) => this.onInputFocus(e)}
                      onChange={(e) => this.handleOTPChange(e, "opt-5")}
                      id="opt-5"
                      className="confirmation-input"
                      type="number"
                      maxLength={1}
                      onInput={this.maxLengthCheck}
                    />
                    <Input
                      onFocus={(e) => this.onInputFocus(e)}
                      onChange={(e) => this.handleOTPChange(e, "opt-6")}
                      id="opt-6"
                      className="confirmation-input"
                      type="number"
                      maxLength={1}
                      onInput={this.maxLengthCheck}
                    />
                  </Form.Item>
                </div>
              </div>
            
              {/* {console.log("this.props.resendCode",this.props.resendCode)} */}
              {/* {console.log("this.props.resendCode",this.props.orangePhoneNumber &&
                          this.props.orangePhoneNumber.length > 0)}
              {console.log("this.props.resendCode",`231077` + this.props.orangePhoneNumber)} */}
              <div
                className="login-forget-password-container"
                onClick={()=>
                  this.props.resendCode
                    ? this.props.resendCode(
                        this.props.orangePhoneNumber &&
                          this.props.orangePhoneNumber.length > 0
                          ? (`231077` + this.props.orangePhoneNumber)
                          : this.props.MTNPhoneNumber &&
                            this.props.MTNPhoneNumber.length > 0
                          ? (`231088`+this.props.MTNPhoneNumber)
                          : null
                      )
                    : this.handleResend()
                }
              >
                <span>Resend the code</span>
              </div>
              <div className="step1-button-container">
                <Button
                  className="next"
                  type="primary"
                  htmlType="submit"
                  loading={this.props.loading}
                >
                  Next
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state, props) => {
  return {
    message: state.auth.forgotPasswordMessage,
    loading: state.auth.loading,
    userData: state.auth.userData,
    destination: state.auth.forgotPasswordDest,
    birthDate: state.auth.birthDate
  };
};

const mapDispatchToProps = (dispatch) => ({
  forgotPasswordConfirm: (data) => dispatch(forgotPasswordConfirm(data)),
  forgotPassword: (userName) => dispatch(forgotPassword(userName)),
});

const WrappedStep1 = Form.create({ name: "ForgotPasswordStep1" })(
  OTPVertification
);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedStep1);
